export default {
  copyTextToInput (input, text) {
    if (!input) return
    input.focus()
    const startPos = input.selectionStart
    const endPos = input.selectionEnd
    const inputText = input.$el.value
    input.$el.value = ''
    input.$el.value = inputText.substring(0, startPos) + text + inputText.substring(endPos, inputText.length)
    input.selectionStart = startPos + text.length
    input.selectionEnd = startPos + text.length
  }
}
